module.exports = {
    PROPERTY_TYPE: {
        "Condominium": "Condo",
        "Single Family Residential": "Single Family",
    },
};
